import r2wc from '@r2wc/react-to-web-component';
import React from 'react';
import LocaleAndThemeProvider from 'src/providers/LocaleAndThemeProvider/LocaleAndThemeProvider.tsx';
import { FeatureFlagsProvider } from 'src/providers/FeatureFlagsProvider/FeatureFlagsProvider.tsx';
import { BrowserRouter } from 'react-router-dom';
import GlobalAvailabilityWidget, {
  SmallOpener,
} from 'src/components/DatesPicker/GlobalAvailabilityWidget';
import { QueryProvider } from 'src/providers/QueryProvider';
import { AuthProvider } from 'src/providers/AuthProvider/AuthProvider';
import SelectedDateRangesProvider from 'src/providers/SelectedDateRangesProvider';

const GlobalAvailabilityWidgetWrapper: React.FC = () => {
  return (
    <AuthProvider>
      <SelectedDateRangesProvider>
        <QueryProvider>
          <BrowserRouter>
            <LocaleAndThemeProvider>
              <FeatureFlagsProvider>
                <GlobalAvailabilityWidget Opener={SmallOpener} />
              </FeatureFlagsProvider>
            </LocaleAndThemeProvider>
          </BrowserRouter>
        </QueryProvider>
      </SelectedDateRangesProvider>
    </AuthProvider>
  );
};

const GlobalAvailabilityWidgetComponent = r2wc(GlobalAvailabilityWidgetWrapper);
export default GlobalAvailabilityWidgetComponent;
